import { ADMIN_PORTAL_COMMONS } from './admin-portal-common.constants';

export interface InstituteDto {
  entity: string;
  brand: string;
  enumValue: string;
  app: string;
  requiredPrivileges?: string[]; // List of privileges that allow access to this institute
}

export class Institute {
  public static readonly PAYLIFE: InstituteDto = {
    entity: '0303',
    brand: 'PayLife',
    enumValue: 'PAYLIFE',
    app: 'paylife',
    requiredPrivileges: ADMIN_PORTAL_COMMONS.PAYLIFE_ACCESS,
  };

  public static readonly BAWAG: InstituteDto = {
    entity: '0100',
    brand: 'BAWAG',
    enumValue: 'BAWAG',
    app: 'klar',
    requiredPrivileges: ADMIN_PORTAL_COMMONS.BAWAG_ACCESS,
  };

  public static readonly PSK: InstituteDto = {
    entity: '0110',
    brand: 'PSK',
    enumValue: 'BAWAG',
    app: 'klar',
    requiredPrivileges: ADMIN_PORTAL_COMMONS.BAWAG_ACCESS,
  };

  public static readonly SPARDA: InstituteDto = {
    entity: '0101',
    brand: 'SPARDA',
    enumValue: 'BAWAG',
    app: 'klar',
    requiredPrivileges: ADMIN_PORTAL_COMMONS.BAWAG_ACCESS,
  };

  public static readonly EASYBANK: InstituteDto = {
    entity: '0109',
    brand: 'easybank',
    enumValue: 'EASYBANK',
    app: 'easybank',
    requiredPrivileges: ADMIN_PORTAL_COMMONS.EASYBANK_ACCESS,
  };

  public static readonly EASYBANK_DE: InstituteDto = {
    entity: '0560',
    brand: 'easybank DE',
    enumValue: 'EASYBANK_GERMANY',
    app: 'easybank-de',
    requiredPrivileges: ADMIN_PORTAL_COMMONS.EASYBANK_ACCESS,
  };

  public static get list(): InstituteDto[] {
    return [
      Institute.BAWAG,
      Institute.EASYBANK,
      Institute.PAYLIFE,
      Institute.EASYBANK_DE,
      // Institute.PSK,
      // Institute.SPARDA,
    ];
  }

  // Includes PSK and SPARDA; used by the Agent Frontend interceptor for bank-identification header.
  public static get FullList(): InstituteDto[] {
    return [
      Institute.BAWAG,
      Institute.EASYBANK,
      Institute.PAYLIFE,
      Institute.EASYBANK_DE,
      Institute.PSK,
      Institute.SPARDA,
    ];
  }
}
